import { emptyStateString } from "@dzambalaorg/draft-js-utils";
import { IPage } from "@framework/types";

export const emptyPage = {
  title: "",
  description: emptyStateString,
} as unknown as IPage;
